import { useState } from "react";
import PropTypes from "prop-types";

const JetHatReveal = ({ jethat, listingId }) => {
  const [revealed, setRevealed] = useState(false);

  function handleClick() {
    setRevealed(true);
    fetch("https://api.emlakjet.com/e6t/v1/events", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        channel: "DESKTOP_WEB",
        reason: "LISTING_DETAIL",
        context: "LISTING",
        event: "VIEW_PHONE_LISTING",
        entityId: listingId,
      }),
    });
  }

  return (
    <div
      style={{
        display: "inline-flex",
        fontSize: 14,
        fontWeight: "normal",
        alignItems: "center",
      }}
    >
      <span style={{ color: "black", fontWeight: "bold" }}>JetHat</span>
      &nbsp;ile ekstra ücret ödemeden arayın&nbsp;
      <span
        onClick={revealed ? undefined : handleClick}
        style={{
          color: "#52ca46",
          cursor: revealed ? "default" : "pointer",
          fontWeight: "bolder",
          fontSize: 14,
          userSelect: "none",
        }}
      >
        {revealed ? jethat : "Telefona Bak"}
      </span>
    </div>
  );
};

JetHatReveal.propTypes = {
  jethat: PropTypes.string.isRequired,
  listingId: PropTypes.number.isRequired,
};

export default JetHatReveal;
